import React from "react";
import { Link } from "react-router-dom"
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import APIConfig from "../../../api/APIConfig";
import ReactLoading from "react-loading";
import {
    Box,
    Center,
    Button,
    Text,
    Stack,
    VStack,
    HStack,
} from '@chakra-ui/react';


function DetailPembayaran() {
    const navigate = useNavigate();
    const [lowonganPeserta, setLowonganPeserta] = useState(null);
    const { id } = useParams();
    const [buktiPembayaran, setBuktiPembayaran] = useState("");
    const [namaProposal, setNamaProposal] = useState("");
    const [namaMitra, setNamaMitra] = useState("");
    const [nominal, setNominal] = useState("");
    const [atasNama, setAtasNama] = useState("");
    const [nomorRekening, setNomorRekening] = useState("");
    const [namaBank, setNamaBank] = useState("");
    const [statusPembayaran, setStatusPembayaran] = useState("");
    const [spinner, setSpinner] = useState(false);  

    const [namaPeserta, setNamaPeserta] = useState("");
    const [emailPeserta, setEmailPeserta] = useState("");

    const getLowonganPeserta = async(id) => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/lowonganpeserta/lowongan/${id}`);
        const data = await response.data
        console.log(data)

        setLowonganPeserta(data);
        setNamaProposal(data.lowongan.proposal.namaProposal)
        setNamaMitra(data.lowongan.mitra.namaResmi)
        setNominal(data.lowongan.proposal.nominal+data.kodeUnik)
        setAtasNama(data.atasNama)
        setNomorRekening(data.nomorRekening)
        setNamaBank(data.namaBank)
        setBuktiPembayaran(data.image);
        setStatusPembayaran(data.statusPembayaran);

        setNamaPeserta(data.peserta.namaPeserta);
        setEmailPeserta(data.peserta.user.emailUser);

        setSpinner(false);
    };

    useEffect(() => {
        getLowonganPeserta(id);        
    }, []);

    const tolakPembayaran = async (e) => {
        e.preventDefault();

        swal("Apakah anda yakin untuk menolak bukti pembayaran ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Kembali",
            value: "no"
            }
        }
        }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/lowonganpeserta/statuspembayaran/${id}`, {
                statusPembayaran: "Ditolak",
            })
            swal({
                title: "Pembayaran ini ditolak!",
                icon: "success",
                button: "OK",
            })
            .then(() => {
                navigate("/admin/verifikasi/pembayaran");
            })
            .catch((error) => {
                console.log(error);
            })
        }
        return false;
        });
    };

    const terimaPembayaran = async (e) => {
        e.preventDefault();

        swal("Apakah anda yakin untuk menerima bukti pembayaran ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Tidak",
            value: "no"
            }
        }
        }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/lowonganpeserta/statuspembayaran/${id}`, {
                statusPembayaran: "Lunas",
            })
            swal({
                title: "Pembayaran ini diterima!",
                icon: "success",
                button: "OK",
            })
            .then(() => {
                navigate("/admin/verifikasi/pembayaran");
            })
            .catch((error) => {
                console.log(error);
            })
        }
        return false;
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'} pb={20}>
            <Text
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Detail Pembayaran
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to="/admin/verifikasi/pembayaran"> Verifikasi Pembayaran </Link>
                <p> / </p>
                <Link to=""> Detail Pembayaran </Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}
                >

                <VStack spacing={4} align='stretch' p={3}>
                    <HStack justifyContent={"space-between"}>
                        <VStack align='stretch' p={3}>
                            <Text
                                color={'gray.700'}
                                fontWeight={600}
                                fontSize={'2xl'}
                                letterSpacing={1.1}>
                                {namaProposal}
                            </Text>
                            <Text
                                paddingBottom={4}
                                color={'gray.700'}
                                fontSize={'s'}>
                                {namaMitra}
                            </Text>
                            <br></br>
                            <Text
                                paddingBottom={4}
                                color={'gray.700'}
                                fontSize={'s'}>
                                {namaPeserta} | {emailPeserta}
                            </Text>
                        </VStack>
                        <VStack align='stretch' p={3}>
                            <Text
                                pt={3}
                                color={'gray.700'}
                                fontSize={'13px'}>
                                Pembayaran
                            </Text>
                            <Text
                                paddingBottom={10}
                                color={'black'}
                                fontWeight={900}
                                fontSize={'13px'}>
                                Rp.{nominal},-
                            </Text>
                        </VStack>
                    </HStack>
                    <div
                    style={{
                        alignContent:"center"}}
                    >
                        <img style={{
                            width: 'auto', 
                            height: '130%',
                            marginTop: '-5px',
                            }} 
                        
                            className="preview" 
                            src={buktiPembayaran} 
                            alt="avatar" />
                    </div>
                </VStack>
                {statusPembayaran !== "Lunas" ?
                <Stack pt={10} justifyContent='right' direction='row' spacing={4} align='center'>
                    <Button 
                        onClick={tolakPembayaran}
                        fontSize={'small'}
                        type='submit'
                        p={4} 
                        rounded={'xl'} 
                        colorScheme='purple' 
                        variant='outline'>
                        Tolak
                    </Button>
                    <Button 
                        onClick={terimaPembayaran}
                        fontSize={'small'}
                        type='submit'
                        p={4}
                        colorScheme='purple' 
                        rounded={'xl'}
                        variant='solid'>
                        Terima
                    </Button>
                </Stack>
                : <div></div> }
            </Box>
        </VStack>
        </Center>
    );
}

export default DetailPembayaran;